import { RootState } from '../store'

export const selectLoadingCreateFeedback = (state: RootState) => state.feedback.loadingCreateFeedback
export const selectErrorCreateFeedback = (state: RootState) => state.feedback.errorCreateFeedback

export const selectLoadingFetchFeedbacks = (state: RootState) => state.feedback.loadingFetchFeedbacks
export const selectErrorFetchFeedbacks = (state: RootState) => state.feedback.errorFetchFeedbacks
